import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { translate as t } from '../../lib/I18n';
import { GlobalModals } from '../../constants/AppConstants';
import ModalActions from '../../actions/ModalActions';
import config from "../../config";
import TrackingActions from "../../actions/TrackingActions";

function RegisterLink ({ onClick, className, isSmartcardDelivery, testId }) {

    const externalRegistrationLink = config.get('externalRegistrationLink');

    const _handleClick = () => {
        if (externalRegistrationLink) {
            TrackingActions.externalLink({ name: 'register' });
            window.open(externalRegistrationLink);
        } else {
            ModalActions.open(GlobalModals.REGISTER, {
                forceSmartcardSignup: isSmartcardDelivery,
                disableSuccessDropdown: isSmartcardDelivery,
            });
            onClick();
        }
    };

    return (
        <button
            role={ externalRegistrationLink ? 'link' : 'button' }
            type="button"
            aria-label={ t('ariaLabel.openRegister') }
            className={ className }
            data-test-id={ testId }
            onClick={ _handleClick }
        >
            { t('account.register') }
        </button>
    );

}

RegisterLink.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    isSmartcardDelivery: PropTypes.bool,
    testId: PropTypes.string,
};

RegisterLink.defaultProps = {
    className: 'btn btn-primary btn-lg btn-register',
    isSmartcardDelivery: false,
    onClick: _.noop,
    testId: 'nav-register-button',
};

export default RegisterLink;
